import { RootState } from 'typesafe-actions';

export function createFeatureSelector<T extends keyof RootState['carousel']>(featureName: T) {
  return (state: RootState) => state?.carousel?.[featureName];
}
